import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, from } from 'rxjs';
import { ChangePasswordDialogComponent } from '../components/change-password-dialog/change-password-dialog.component';
import { BaseModalSize } from '@shared/ui/modal';
import { ChangePinDialogComponent } from '../components/change-pin-dialog/change-pin-dialog.component';
import { ChangeProfileDialogComponent } from '../components/change-profile-dialog/change-profile-dialog.component';
import { DownloadAllEvidenceDialogComponent } from '../components/download-all-evidence-dialog/download-all-evidence-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class LayoutModalService {
  constructor(private ngbModal: NgbModal) {}

  openPassword(): Observable<boolean> {
    const modal = this.ngbModal.open(ChangePasswordDialogComponent, { size: BaseModalSize.ExtraLarge });

    return from(
      modal.result.then(
        () => true,
        () => false
      )
    );
  }

  openChangePinModal(): void {
    this.ngbModal.open(ChangePinDialogComponent, { size: BaseModalSize.ExtraLarge });
  }

  openChangeProfileModal(): void {
    this.ngbModal.open(ChangeProfileDialogComponent, { size: BaseModalSize.ExtraLarge });
  }

  openDownloadAllEvidenceDialog(hasLockedEvidence: boolean): Observable<boolean> {
    const modal = this.ngbModal.open(DownloadAllEvidenceDialogComponent, { size: BaseModalSize.Large });
    modal.componentInstance.hasLockedEvidence = hasLockedEvidence;

    return from(
      modal.result.then(
        () => true,
        () => false
      )
    );
  }
}
